import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import installElementPlus from "./plugins/element.plugin";
import installi18n from "./plugins/i18n.plugin";
import { setupAxiosInterceptor } from "./config/axios-interceptor.config";
import { setupGlobalError } from "./config/global-error.config";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
setupAxiosInterceptor(store);

const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
installi18n(app);
installElementPlus(app);

app.use(router).use(store);

setupGlobalError(app);

app.mount("#app");
